<gp-modal #populationModal [closable]="false" size="lg">
  <div class="gp-modal-title" test-id="create-population-modal-tittle">
    <h4 class="text-ellipsis">{{'CONTEXT_BAR.population_selection_criteria' | translate}}</h4>
  </div>
  <div class="gp-modal-body clearfix population-modal" test-id="create-population-modal-body">
    <div *ngIf="loading" class="padding text-center">
      <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
    </div>
    <form [formGroup]="populationForm" *ngIf="!loading" test-id="create-population-form">
      <!--------------------------CONTRACT BEGIN DATE------------------------------------>
      <div class="row p-a-sm" formGroupName="contractBeginDate">
        <div class="col-sm-4">
         <span test-id="create-population-_contract-begin-date-label">
           {{'CONTEXT_BAR.contract_begin_date' | translate}}
         </span>
        </div>
        <div class="col-sm-2">
          <gp-dropdown-select formControlName="operator"
                              [direction]="'auto'"
                              [buttonClasses]="['btn', 'pull-right']"
                              [forceDisplayValue]="getOperatorDisplayValue('contractBeginDate', 'DATE', false)"
                              test-id="create-population-_contract-begin-date-operator-dropdown"
                              ngDefaultControl>
            <gp-dropdown-option *ngFor="let sign of getConditionalOperators('DATE')" [ngValue]="sign.value">
              {{ sign.display | translate }} {{sign.description | translate}}
            </gp-dropdown-option>
          </gp-dropdown-select>
        </div>
        <div class="col-sm-6">
          <input type="text"
                 class="form-control"
                 bsDatepicker
                 test-id="create-population-_contract-begin-date"
                 formControlName="criterionValue"
                 [bsConfig]="{dateInputFormat: dateFormat, containerClass: 'theme-default'}"/>
        </div>
      </div>
      <!--------------------------CONTRACT END DATE------------------------------------>
      <div class="row p-a-sm" formGroupName="contractEndDate">
        <div class="col-sm-4">
          <span test-id="create-population-_contract-end-date-label">
            {{'CONTEXT_BAR.contract_end_date' | translate}}
          </span>
        </div>
        <div class="col-sm-2">
          <gp-dropdown-select formControlName="operator"
                              [direction]="'auto'"
                              [buttonClasses]="['btn', 'pull-right']"
                              [forceDisplayValue]="getOperatorDisplayValue('contractEndDate', 'DATE', false)"
                              test-id="create-population-_contract-end-date-operator-dropdown"
                              ngDefaultControl>
            <gp-dropdown-option *ngFor="let sign of getConditionalOperators('DATE')" [ngValue]="sign.value">
              {{ sign.display | translate }} {{sign.description | translate}}
            </gp-dropdown-option>
          </gp-dropdown-select>
        </div>
        <div class="col-sm-6">
          <input type="text"
                 class="form-control"
                 bsDatepicker
                 test-id="create-population-_contract-end-date"
                 formControlName="criterionValue"
                 [bsConfig]="{dateInputFormat: dateFormat, containerClass: 'theme-default'}"/>
        </div>
      </div>
      <!---------------------------CONTRACT STATUS ---------------------------->
      <div class="row p-a-sm" formGroupName="contractStatus">
        <div class="col-sm-4">
          <span test-id="create-population-_contract-status-label">
            {{'CONTEXT_BAR.contract_status' | translate}}
          </span>
        </div>
        <div class="col-sm-2">
          <gp-dropdown-select formControlName="operator"
                              [direction]="'auto'"
                              [buttonClasses]="['btn', 'pull-right']"
                              [forceDisplayValue]="getOperatorDisplayValue('contractStatus', 'LIST', false)"
                              test-id="create-population-_contract-status-operator-dropdown"
                              ngDefaultControl>
            <gp-dropdown-option *ngFor="let sign of getConditionalOperators('LIST')" [ngValue]="sign.value">
              {{ sign.display | translate }} {{sign.description | translate}}
            </gp-dropdown-option>
          </gp-dropdown-select>
        </div>
        <div class="col-sm-6">
          <ng-select
            class="form-control"
            test-id="create-population-_contract-status"
            formControlName="criterionValue"
            [idField]="'value'"
            [textField]="'display'"
            [items]="contractStatuses | sort: 'display'"
            ngDefaultControl>
          </ng-select>
        </div>
      </div>
      <!--------------------------CRITERIA------------------------------------>

      <div formArrayName="criteria"
           *ngFor="let criterion of criteriaDescriptors; let i = index">
        <div [formGroupName]="i" class="row p-a-sm">
          <div class="col-sm-4">
            <span [attr.test-id]="'create-population-' + criterion.zoneID + '-label'">
              {{criterion.transIdsTranslations.join(' / ')}}
            </span>
          </div>
          <div class="col-sm-2">
            <gp-dropdown-select formControlName="operator"
                                [direction]="'auto'"
                                [buttonClasses]="['btn', 'pull-right']"
                                [forceDisplayValue]="getOperatorDisplayValue(i, criterion.type, true)"
                                [attr.test-id]="'create-population-' + criterion.zoneID + '-operator-dropdown'"
                                ngDefaultControl>
              <gp-dropdown-option *ngFor="let sign of getConditionalOperators(criterion.type)" [ngValue]="sign.value" (click)="onOperatorChange(i, sign.value)">
                {{ sign.display | translate }} {{sign.description | translate}}
              </gp-dropdown-option>
            </gp-dropdown-select>
          </div>
          <div class="col-sm-6">
            <ng-container [ngSwitch]="criterion.type">
              <!--------------------------DATE FIELD----------------------------------------------->
              <input *ngSwitchCase="'DATE'"
                     type="text"
                     class="form-control"
                     bsDatepicker
                     [attr.test-id]="'create-population-' + criterion.zoneID + '-date-input'"
                     formControlName="criterionValue"
                     [bsConfig]="{dateInputFormat: dateFormat, containerClass: 'theme-default'}"/>
              <!---------------------------ENTITY-------------------------------------------------->
              <gp-population-entity-field *ngSwitchCase="'ENTITY'"
                                          [populationForm]="populationForm"
                                          [index]="i"
                                          [criterion]="criterion"
                                          [selectedOperator]="populationForm.get(['criteria', i, 'operator'])?.value"
                                          [populationCriteriaCookie]="populationCriteriaCookie"
                                          (selectedEntityNameAvailable)="onPopulationEntitySelected($event, criterion)">
              </gp-population-entity-field>
              <!---------------------------LIST-------------------------------------------------->
              <ng-select *ngSwitchCase="'LIST'"
                         formControlName="criterionValue"
                         class="form-control"
                         [attr.test-id]="'create-population-' + criterion.zoneID + '-select'"
                         [idField]="'value'"
                         [textField]="'display'"
                         [items]="criterion.metadatas.items | sort: 'display'">
              </ng-select>
              <!--------------------------LABEL AND TEXT FIELD------------------------------------>
              <input *ngSwitchDefault
                     class="form-control"
                     [attr.test-id]="'create-population-' + criterion.zoneID + 'text-input'"
                     formControlName="criterionValue"
                     type="text">
            </ng-container>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="gp-modal-footer" test-id="create-population-modal-footer">
    <button type="button"
            test-id="create-population-clear-all-filters-btn"
            class="btn p-x-d btn-outline b-primary text-white pull-left"
            [disabled]="!criteriaHasValues()"
            (click)="resetPopulationForm()">
      {{'CONTEXT_BAR.clear_all_filters' | translate}}
    </button>
    <button type="button"
            test-id="create-population-cancel-btn"
            class="btn dark-white p-x-md"
            (click)="cancelNewPopulation(populationModal)">
      {{ 'FORMS.cancel' | translate }}
    </button>
    <button class="btn btn-dark p-x-md"
            (click)="applyPopulation(populationModal)"
            test-id="create-population-apply-btn"
            [disabled]="populationForm.invalid || loading"
            id="confirmButton">
      {{'CONTEXT_BAR.apply' | translate}}
    </button>
  </div>
</gp-modal>
